import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";

const url = GlobalConstants.urlApi;

const getProveedores = () => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        }
    };

    return fetch(`${url}/unoauno/proveedores/getProveedores`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getProveedoresNombres = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/proveedores/getProveedoresNombres`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const getProveedoresImagenes = () => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        }
    };

    return fetch(`${url}/unoauno/proveedores/getProveedoresImagenes`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idProveedor, nombreImg, extension}) => {
    const formData = new FormData();

    formData.append('id', idProveedor.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/proveedores/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const proveedoresService = {
    getProveedores,
    getProveedoresNombres,
    getProveedoresImagenes,
    saveImagen
};